module.exports = __webpack_public_path__ + "img/2x.15bc428.jpg";